import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {
	MultiUpdateWarrantyRequestBody,
	UpdateWarrantyRequestBody,
	WarrantyTypes
} from '../../services/warranty.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {QuotationEntry} from '../au-operation-working-detail/working-manager/working-manager.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component ({
	selector: 'amd-authority-warranty-dialog',
	templateUrl: './authority-warranty-dialog.component.html',
	styleUrls: ['./authority-warranty-dialog.component.scss']
})
export class AuthorityWarrantyDialogComponent implements OnInit {

	form: FormGroup;
	multiEditWarrantyType: boolean;
	isExWarrantyType: boolean;
	warrantyValues: any = WarrantyTypes;
	warrantyType: string;
	selectedEntries: QuotationEntry[];
	translateContext: TranslateContext = TranslateContext.AUTHORITY;

	constructor(
		private dialogRef: MatDialogRef<AuthorityWarrantyDialogComponent>,
		private formBuilder: FormBuilder,
		@Inject (MAT_DIALOG_DATA) private data: any ) {
		this.multiEditWarrantyType = this.data.multiEditWarrantyType;
		this.isExWarrantyType =  this.data.isExWarrantyType;
		this.selectedEntries = this.data.selectedEntries;

		if (this.isExWarrantyType) {
			this.warrantyType = this.data.warrantyType;
		}
	}

	ngOnInit(): void {
		this.form = this.formBuilder.group ({
			discount_percentage: [null, [Validators.required, Validators.max (100), Validators.min (0), Validators.pattern(Utilities.patternOnlyIntergerNumber)]],
			note: [null]
		});
	}

	confirmDisabled(): boolean {
		return this.multiEditWarrantyType && this.warrantyType !== WarrantyTypes.EX ? false : this.form.invalid;
	}

	close(): void {
		this.dialogRef.close ();
	}

	confirm(): void {
		let discount_percentage: string, note: string;
		if (this.warrantyType !== WarrantyTypes.EX) {
			discount_percentage = null;
			note = null;
		} else {
			discount_percentage = this.form.get ('discount_percentage').value;
			note = this.form.get ('note').value;
		}

		let warrantyRequestBody: any;

		if (this.multiEditWarrantyType) {
			const id_list: string[] = [];

			this.selectedEntries.filter( entry => entry.isNew).forEach( el => {
				id_list.push(el.id);
			});
			warrantyRequestBody = {
				id_list: id_list,
				warranty_type_request: {
					warranty_type: this.warrantyType,
					discount_percentage: discount_percentage,
					note: note
				}
			};
		}

		if (this.isExWarrantyType) {
			warrantyRequestBody = {
				warranty_type: this.warrantyType,
				discount_percentage: discount_percentage,
				note: note};
		}
		this.dialogRef.close (warrantyRequestBody);
	}
}
